// The page address that goes into our error log (app_errors.url): never the #hash (a login / recovery redirect carries
// #access_token=...&refresh_token=...) and never a secret in the query (?code= of the PKCE login, token, key ...).
// Used by the browser (src/errorlog.js) and again by the server before storing (api/_errlog.js logError). final-fix, sec-check 7.3.
const SECRET = /^(access_token|refresh_token|provider_token|provider_refresh_token|id_token|token|token_hash|code|key|apikey|api_key|secret|password|signature|sig)$/i

export function safeLogUrl(u) {
  if (u == null) return null
  const s = String(u).split('#')[0]
  const q = s.indexOf('?')
  if (q < 0) return s
  const parts = s.slice(q + 1).split('&').filter(Boolean).map(kv => {
    const k = kv.split('=')[0]
    let name = k
    try { name = decodeURIComponent(k) } catch (e) {}
    return SECRET.test(name) ? k + '=(hidden)' : kv
  })
  return s.slice(0, q) + (parts.length ? '?' + parts.join('&') : '')
}
